import { getDefaultStore } from "jotai";
import { RESET } from "jotai/utils";

import { CustomerIO } from "@repo/customerio-plugin";

import { resolvedUserAtom } from "@/lib/atoms/resolved-user-atom";
import { createInitialUser } from "@/lib/create-initial-user";
import { iosOrAndroid } from "@/lib/utils/config";
import type { RootRouteContext } from "@/routes/-root/-root-context";

const clearCustomerIoIdentify = (): void => {
  if (iosOrAndroid) {
    CustomerIO.clearIdentify();
  }
};

export const logout = async (context: RootRouteContext): Promise<void> => {
  // Limpa o estado local síncrono primeiro, para que não dependa do término das
  // operações assíncronas abaixo (que podem demorar ou navegar a página, no Auth0).
  clearCustomerIoIdentify();
  // Reseta a identidade do RudderStack antes de recriar o usuário inicial, para
  // não vazar userId/anonymousId do usuário anterior em aparelho compartilhado /
  // re-login (optional chaining pois o SDK pode não ter carregado). Ver CBR-3937.
  window.rudderanalytics?.reset();
  context.user = createInitialUser();
  getDefaultStore().set(resolvedUserAtom, RESET);
  context.queryClient.clear();

  await context.ldClient.resetContext();
  await context.authClient.logout();
};
